/**
 * PageHeader (Compact)
 *
 * Komponen header halaman yang terpusat untuk seluruh halaman Booku V2.
 *
 * Pattern compact density:
 * - Title satu baris (font-size-xl), inline dengan tooltip ⓘ di kanan
 * - Subtitle/deskripsi disampaikan via tooltip (hover ikon ⓘ), bukan baris terpisah
 * - Action buttons di kanan (header-right)
 *
 * Pengganti pattern lama:
 *   <div className="content-header">
 *     <div className="content-header-left">
 *       <h1 className="content-title">Title</h1>
 *       <p className="content-subtitle">Subtitle</p>
 *     </div>
 *     <div className="content-header-right">{actions}</div>
 *   </div>
 *
 * Pemakaian baru:
 *   <PageHeader
 *     title="Buku Besar - Kas Mahani"
 *     description="General Ledger - daftar transaksi per akun"
 *     actions={<><Button>Refresh</Button><Button>Export</Button></>}
 *   />
 *
 * @see .claude/docs/Booku v2/ui-patterns/compact-density-pattern.md
 * @see .claude/docs/Booku v2/ui-patterns/page-layout-pattern.md
 */

import type { ReactNode } from 'react';
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

interface PageHeaderProps {
  /** Judul halaman (1 baris, akan terpotong dengan ellipsis bila terlalu panjang) */
  title: ReactNode;
  /**
   * Deskripsi singkat halaman.
   * Akan ditampilkan sebagai tooltip pada ikon ⓘ di sebelah kanan title.
   * Jika tidak diisi, ikon tooltip tidak ditampilkan.
   */
  description?: ReactNode;
  /** Tombol aksi di sisi kanan header (Refresh, Export, Tambah, dll.) */
  actions?: ReactNode;
}

export function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <div className="content-header">
      <div className="content-header-left">
        <h1 className="content-title">{title}</h1>
        {description && (
          <Tooltip title={description} placement="right">
            <span className="content-title-info" aria-label="Info">
              <InfoCircleOutlined />
            </span>
          </Tooltip>
        )}
      </div>
      {actions && <div className="content-header-right">{actions}</div>}
    </div>
  );
}
